module.exports = __webpack_public_path__ + "static/media/bottom_banner_5_2.bb189f98.png";